<div class="container confirm-container">
  <mat-dialog-content #template [style]="data.style"></mat-dialog-content>
  <mat-dialog-actions class="stackbtn">
    <button mat-dialog-close mat-button class="cancel" *ngIf="data.cancelText">
      {{ data.cancelText }}
    </button>
    <button [mat-dialog-close]="true" mat-button class="excute">
      {{ data.excuteText }}
    </button>
  </mat-dialog-actions>

</div>